import { ResourceAppModule } from "@/shared/app";
import { plmApp } from "../app";
import {
  ObiektZastosowania,
  obiektZastosowaniaResource,
} from "@megarax/client/src/resources/plm";

export const obiektZastosowaniaModule: ResourceAppModule = {
  app: plmApp,
  formComponent: () => import("./ItemForm.vue"),
  sheetComponent: () => import("./ItemSheet.vue"),
  listComponent: () => import("./ItemList.vue"),
  title: "Obiekty zastosowania",
  route: "obiektZastosowania",
  itemConstructor: ObiektZastosowania,
  resource: obiektZastosowaniaResource,
};
